import { getExamples } from '../../../examples';

const examples = getExamples();

export default examples;
